module.exports = __webpack_public_path__ + "img/mes-capture-imposition.27ecb86d.png";